import transitions from '@material-ui/core/styles/transitions';
import { colors } from '../../constants';
import { SHADOW_LEVEL1 } from '../../shadows';
const MuiMobileStepper = {
  root: {
    backgroundColor: 'transparent'
  },
  dotActive: {
    backgroundColor: colors.secondary.main,
    transform: 'scale(1.5)',
    boxShadow: SHADOW_LEVEL1
  },
  dots: {
    alignItems: 'center'
  },
  dot: {
    transition: transitions.create(['transform', 'box-shadow', 'background-color'], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.short
    }),
    willChange: 'transform, box-shadow, background-color',
    backgroundColor: colors.oriGrey[200],
    margin: '0 5px'
  }
};
export default MuiMobileStepper;